import axios from 'axios';
import { API_BASE_URL } from './config';
import Cookies from 'universal-cookie';
const cookies=new Cookies();
 
const baseUrl = API_BASE_URL;

const instance = axios.create({
    baseURL: baseUrl,
    timeout: 15000
  });   

export async function getBlogs() {
    try {
      const response = await instance.get('/api/blog');
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error; // Rethrow the error to be handled by the calling code
    }
  }

  export async function insertBlog(blogData) {
    try {
      const response = await instance.post('/api/insertblog', blogData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${cookies.get("token")}`,
        },
      });
  
      return response.data;
    } catch (error) {
      console.error('Error inserting data:', error);
      throw error; // Rethrow the error to be handled by the calling code
    }
  }

  export async function deleteBlog(blogData) {
    try {
      const jsonData = JSON.stringify(blogData);
      const response = await instance.post('/api/deleteblog', jsonData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${cookies.get("token")}`, 
        },
      });
  
      return response.data;
    } catch (error) {
      console.error('Error deleting data:', error);
      throw error; // Rethrow the error to be handled by the calling code
    }
  }

  export async function updateBlog(blogData) {
    try {
      const jsonData = JSON.stringify(blogData);
      const response = await instance.post('/api/updateblog',jsonData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${cookies.get("token")}`, 
        },
      });
  
      return response.data;
    } catch (error) {
      console.error('Error updating data:', error);
      throw error; // Rethrow the error to be handled by the calling code
    }
  }


// Numbers keep their articles and dossier embedded in the same document.
export async function getRevistas() {
    const response = await instance.get('/api/revista');
    return response.data;
}

function adminHeaders() {
    return { headers: { Authorization: `Bearer ${cookies.get('token')}` } };
}

export async function insertRevista(data) {
    const response = await instance.post('/api/insertrevista', data, adminHeaders());
    return response.data;
}

export async function updateRevista(data) {
    const response = await instance.post('/api/updaterevista', data, adminHeaders());
    return response.data;
}

export async function deleteRevista(id) {
    const response = await instance.post('/api/deleterevista', { id }, adminHeaders());
    return response.data;
}
